import oauth from "@/common/social.config";

function buildURL(url, params) {
  if (!url) return "";
  if (!params) return url;

  const searchParams = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null) continue;
    searchParams.append(key, String(value));
  }

  const query = searchParams.toString();
  if (!query) return url;

  const joiner = url.includes("?") ? "&" : "?";
  return `${url}${joiner}${query}`;
}

const state = {
  oauth,
  redirectPath: localStorage.getItem("redirectPath") || "/",
};

const getters = {
  oauthUrl: (state) => (provider) => {
    const url = state.oauth[provider]?.url;
    const params = state.oauth[provider]?.params;
    return buildURL(url, params);
  },

  getRedirectPath: (state) => {
    return state.redirectPath.startsWith("/") ? state.redirectPath : "/";
  },
};

const actions = {
  setRedirectPath({ commit }, path) {
    if (path && path.startsWith("/")) {
      commit("setRedirectPath", path);
    } else {
      commit("resetRedirectPath");
    }
  },

  resetRedirectPath({ commit }) {
    commit("resetRedirectPath");
  },
};

const mutations = {
  setRedirectPath(state, path) {
    state.redirectPath = path;
    localStorage.setItem("redirectPath", path);
  },

  resetRedirectPath(state) {
    state.redirectPath = "/";
    localStorage.removeItem("redirectPath");
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
